import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import AuthProvider from './app/Context/auth';

const root = ReactDOM.createRoot(document.getElementById('root'));

// --- GLOBAL FETCH INTERCEPTOR FOR SESSION MANAGEMENT ---
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  config = config || {};

  // Retrieve session ID from storage
  const sessionId = localStorage.getItem('sessionId');

  // Verify if the request is for an external service (Google/Firebase)
  const isExternal = typeof resource === 'string' && (
    resource.includes('googleapis.com') ||
    resource.includes('firebase') ||
    resource.includes('gstatic.com') ||
    resource.includes('viacep.com.br') ||
    resource.includes('ibge.gov.br')
  );

  if (sessionId && !isExternal) {
    config.headers = {
      ...config.headers,
      'x-session-id': sessionId
    };
  }

  // Execute request
  const response = await originalFetch(resource, config);

  // --- GLOBAL ERROR HANDLING (401 - Session Expired/Invalid) ---
  if (response.status === 401) {
    try {
      const clone = response.clone(); // Clone to read body without consuming original
      const data = await clone.json();
      const errorMessage = data.error || "Sessão expirada. Faça login novamente.";

      // Clear session data
      localStorage.removeItem('sessionId');

      // Redirect to Login if not already there
      if (!window.location.pathname.endsWith('/app')) {
        // Using window.history.replaceState to pass the message to the new page state
        // We need to navigate using window.location for a hard redirect since we don't have router access here easily

        // Let's use `window.history.pushState` with the target URL and then force react router to pick it up?
        // Since this is outside the React Tree, we can't trigger React Router navigation.
        // Hard reload is safer to clear any stale state.

        // Let's go with: Redirect.
        // To Show Message: We can use sessionStorage.
        sessionStorage.setItem('loginMessage', errorMessage);
        window.location.href = '/app';
      }
    } catch (e) {
      // If JSON parse fails, just redirect
      localStorage.removeItem('sessionId');
      if (!window.location.pathname.endsWith('/app')) {
        window.location.href = '/app';
      }
    }
  }

  return response;
};
// -----------------------------------------------------

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
);
